export const it: any = {
    messages: {
        hello: 'ciao',
        tooltip:{
          cambia_lingua: 'Cambia lingua',
          info: "Informazioni",
          home: 'Vai alla home',
          logout: 'Logout',
          login: 'Entra',
          admin: 'Sezione admin'
        },
        menu: {
            cerca:'CERCA',
            home: 'home',
            mappe: 'mappe',
            info: 'info',
            news: 'news',
            archivi: 'archivi',
            login: 'login',
            logout: 'logout',
        },
        login: {
            username: 'Username',
            password: 'Password',
            accesso: 'Accesso',
            titolo: 'Accesso al sistema di amministrazione',
            // sottotitolo: 'Quest\'area è riservata agli amministratori e gestori del sistema.',
        },
        // home: {
        //     titolo: 'Lorem ipsum dolor sit amet,\n' +
        //         'consectetur adipiscing elit.',
        //     sottotitolo: 'Sed do eiusmod tempor incididunt',
        // },
        tab: {
            firstTab: 'Home',
            // titolo: 'Lorem ipsum dolor sit amet.',
            // sottotitolo: 'Sottotitolo',
            // descrizione: 'In questa sezione puoi trovare una serie di mappe tematiche che riguardano la\n' +
            //     'biodiversità, la storia e la gestione del Parco Nazionale. Molte di queste contengono utili\n' +
            //     'informazioni alle quali potrai accedere\n' +
            //     'con il semplice utilizzo del mouse. Le mappe sono in continuo aggiornamento con i nuovi dati in\n' +
            //     'possesso del Parco e la sezione verrà sempre arricchita da nuovi contenuti.\n' +
            //     'Scegli l\'area tematica di tuo interesse e scopri tutte le informazioni su mappa che riguardano\n' +
            //     'l\'Area protetta.',
        },
        about: {
            chisiamo: 'chi siamo',
            telefono: 'contatti telefonici',
            email: 'indirizzo email',
            dovesiamo: 'dove siamo',
            social: 'social',
        },
        language: {
            it: 'ita',
            en: 'eng',
        },
        validation: {
            requiredField: 'Questo campo è obbligatorio',
            erroreLogin: 'Errore di login',
        },
    },
};
